<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
  </entity-list-table>
</template>

<script>
  import PriceListDataService from '@/services/api/PriceListDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Прайс-листы',
        dataService: PriceListDataService,
        createRouteName: 'price-list-create',
        editRouteName: 'price-list-edit',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
        ],

        allowDelete: true,
        showStatusColumn: false,
      }
    },
  }
</script>
